"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireDefault(require("react"));

var _propTypes = babelHelpers.interopRequireDefault(require("prop-types"));

var _shallowEqual = babelHelpers.interopRequireDefault(require("../utils/shallowEqual"));

// @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-flow-strip-types", "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}
var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var className = props.className,
      elementRef = props.elementRef,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onReady = props.onReady,
      options = babelHelpers.objectWithoutProperties(props, ["className", "elementRef", "onChange", "onFocus", "onBlur", "onReady"]);
  return options;
};

var Element = function Element(type) {
  var _class, _temp;

  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    babelHelpers.inherits(_class, _React$Component);

    function _class(props, context) {
      var _this;

      babelHelpers.classCallCheck(this, _class);
      _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class).call(this, props, context));

      _this.handleRef = function (ref) {
        _this._ref = ref;
      };

      var options = _extractOptions(_this.props);

      _this._element = _this.context.elements.create(type, options);

      _this._setupEventListeners();

      _this._options = options;
      return _this;
    }

    babelHelpers.createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this._element.mount(this._ref);

        if (hocOptions.sourceType) {
          this.context.registerElement(hocOptions.sourceType, this._element);
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var options = _extractOptions(nextProps);

        if (Object.keys(options).length !== 0 && !(0, _shallowEqual.default)(options, this._options)) {
          this._options = options;

          this._element.update(options);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._element.destroy();

        this.context.unregisterElement(this._element);
      }
    }, {
      key: "_setupEventListeners",
      value: function _setupEventListeners() {
        var _this2 = this;

        this._element.on('ready', function () {
          _this2.props.elementRef(_this2._element);

          _this2.props.onReady();
        });

        this._element.on('change', function (change) {
          _this2.props.onChange(change);
        });

        this._element.on('blur', function () {
          var _this2$props;

          return (_this2$props = _this2.props).onBlur.apply(_this2$props, arguments);
        });

        this._element.on('focus', function () {
          var _this2$props2;

          return (_this2$props2 = _this2.props).onFocus.apply(_this2$props2, arguments);
        });
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement("div", {
          className: this.props.className,
          ref: this.handleRef
        });
      }
    }]);
    return _class;
  }(_react.default.Component), _class.displayName = "StripeElement(".concat(type, ")"), _class.propTypes = {
    className: _propTypes.default.string,
    elementRef: _propTypes.default.func,
    onChange: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onReady: _propTypes.default.func
  }, _class.defaultProps = {
    className: '',
    elementRef: noop,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    onReady: noop
  }, _class.contextTypes = {
    elements: _propTypes.default.object.isRequired,
    registerElement: _propTypes.default.func.isRequired,
    unregisterElement: _propTypes.default.func.isRequired
  }, _temp;
};

var _default = Element;
exports.default = _default;